import React from 'react';
import { LawFirmPopover } from '../../law-firm/popover/LawFirmPopover';
import { LawyerPopover } from '../../lawyer/popover/LawyerPopover';
import { EnterprisePopover } from '../../enterprise/popover/EnterprisePopover';
import { LegislationPopover } from '../../legislation/popover/LegislationPopover';

type Props = {
  source: string;
  element: HTMLElement;
};

export function PopoverSelectionFromDataAttribute(props: Props) {
  const { element, source } = props;
  const articleId = element.getAttribute('data-legislation');
  if (articleId) {
    return <LegislationPopover articleId={articleId} source={source} />;
  }
  const siren = element.getAttribute('data-enterprise');
  if (siren) {
    return <EnterprisePopover siren={siren} source={source} />;
  }
  const lawyerId = element.getAttribute('data-lawyer');
  if (lawyerId) {
    return <LawyerPopover lawyerId={lawyerId} source={source} />;
  }
  const lawOfficeIdGroup = element.getAttribute('data-law-firm');
  if (lawOfficeIdGroup) {
    return (
      <LawFirmPopover lawOfficeIdGroup={lawOfficeIdGroup} source={source} />
    );
  }
  return null;
}
